import { render, staticRenderFns } from "./SuspiciousGroupJoinQuestion.vue?vue&type=template&id=3823ccb0&scoped=true&"
import script from "./SuspiciousGroupJoinQuestion.vue?vue&type=script&lang=js&"
export * from "./SuspiciousGroupJoinQuestion.vue?vue&type=script&lang=js&"
import style0 from "./SuspiciousGroupJoinQuestion.vue?vue&type=style&index=0&id=3823ccb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3823ccb0",
  null
  
)

export default component.exports